import { useTheme } from "next-themes";
import { useState } from "react";

import DcclLogo from "./../assets/DCCL-Logo.png";
import { customCancelButton, customLoginButton, customRecoverButton, themeBasedSignupFormControl } from "../components/customStyles";
import { forgotPassword } from "../services/auth.service";
import { useNavigate } from "react-router-dom";
import useBreakpoint from "../hooks/useBreakpoint";
import toast from "react-hot-toast";
import { customToast } from "../components/toasts";
import { encodeEmailAndStore } from "../utils/crypto";
import { sessionStorageUtil } from "../utils/storage";
import { useTranslation } from "react-i18next";
import LogoDark from '../assets/InvestorApp.png';
import { useI18n } from "../hooks/useI18n";

function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [formProcessing, setFormProcessing] = useState(false);

  const { theme } = useTheme();
  const { t } = useTranslation();
  const { isRTL } = useI18n();

  const navigate = useNavigate();

  const screenSize = useBreakpoint();

  const navigateToLogin = () => {
    navigate("/auth/login");
  };

  const sendForgotPasswordReq = async () => {
    setFormProcessing(true);

    try {
      const data = await forgotPassword(email);

      sessionStorageUtil.setUserEmail(email);

      // encodeEmailAndStore(email);

      await new Promise((res) => setTimeout(() => res(), 1000));

      if (!data.error) {
        toast((t) => customToast(data.message, "success", t), {
          duration: 3000,
          removeDelay: 1000,
          style: {
            padding: "0.75rem",
            margin: "0",
            minWidth: "200px",
            backgroundColor: "rgb(255,255,255)",
          },
        });

        navigate("/auth/recover/update", { state: email });
      } else {
        if (Array.isArray(data.message)) {
          const errMessages = data.message;

          errMessages.forEach((msg, i) => {
            setTimeout(() => {
              toast((t) => customToast(msg, "error", t), {
                duration: 3000,
                removeDelay: 1000,
                style: {
                  padding: "0.75rem",
                  margin: "0",
                  width: "300px",
                  maxWidth: "100%",
                  // color: theme === 'light' ? 'rgb(33,37,41)' : 'rgb(230, 230, 230)',
                  // backgroundColor: theme === 'light' ? 'rgba(255,255,255,.9)' : 'rgb(51, 34, 61)'
                  color: "rgb(33,37,41)",
                  backgroundColor: "rgb(221, 204, 225)",
                },
              });
            }, i * 350);
          });
        } else {
          toast((t) => customToast(data.message, "error", t), {
            duration: 3000,
            removeDelay: 1000,
            style: {
              padding: "0.75rem",
              margin: "0",
              minWidth: "200px",
              backgroundColor: "rgb(221, 204, 225)",
            },
          });
        }
      }

      return data;
    } finally {
      setFormProcessing((prev) => !prev);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!emailError) {
      sendForgotPasswordReq();
    }
  };

  return (
    <div
      className={`add-custom-scroll${theme === "dark" ? "-dark" : ""} container-fluid w-100 d-flex mx-auto flex-column justify-content-start flex-nowrap`}
      style={{
        fontFamily: isRTL ? "var(--font-urdu)" : '"Barlow Condensed", "Kanit"',
        backgroundColor: "var(--theme-bg)",
        padding: screenSize <= 575 ? "8px 8px 8px 8px" : "4px 10px 10px 12px",
        borderRadius: "20px",
        rowGap: "8px",
        height: screenSize <= 575 ? "calc(100dvh - 148px)" : screenSize <= 991 && screenSize >= 576 ? "calc(100dvh - 202px)" : "calc(100dvh - 128px)",
        overflowY: "auto",
      }}
    >
      <div className='row w-100 flex-column align-items-center justify-content-between mx-auto py-3 flex-nowrap' style={{
        height: '100%',
        minHeight: '700px'
      }}>
        <div className='col-auto p-0 text-center'>
              <img className="" src={LogoDark} style={{
                width: '300px',
                objectFit: 'contain',
                maxWidth: '100%'
              }}/>
          {/* <svg
            xmlns='http://www.w3.org/2000/svg'
            width={140}
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeWidth={1.25}
            strokeLinecap='round'
            strokeLinejoin='round'
            className='icon icon-tabler icons-tabler-outline icon-tabler-stack-2 mx-auto'
            style={{
              color: "rgba(255,255,255,0.85)",
              overflow: "visible",
            }}
          >
            <path stroke='none' d='M0 0h24v24H0z' fill='none' />
            <path d='M12 4l-8 4l8 4l8 -4l-8 -4' />
            <path d='M4 12l8 4l8 -4' />
            <path d='M4 16l8 4l8 -4' />
          </svg>
          <div
            className=''
            style={{
              fontSize: "3rem",
              fontWeight: "700",
              letterSpacing: "0.02em",
              lineHeight: "1",
              color: "rgba(255, 255, 255, 0.9)",
            }}
          >
            One-App
          </div> */}
        </div>
        <div className='col-auto p-0 px-2 px-sm-4'>
          {/* <div className="text-center" style={{
						lineHeight: '1',
						fontSize: '1.2rem',
						color: 'rgba(255,255,255,0.7)'
					}}>
						Login via
					</div> */}

          <form
            className=''
            onSubmit={handleSubmit}
            style={{
              marginTop: "2.5rem",
              marginBottom: "3rem",
              width: "460px",
              maxWidth: "100%",
              backgroundColor: theme === "dark" ? "rgba(90, 90, 90, .6)" : "rgb(198, 204, 227, .38)",
              border: "1px solid rgba(255,255,255,.15)",
              borderRadius: ".5rem",
              padding: screenSize === "sm" ? "1.75rem 1.5rem 1.9rem 1.5rem" : "1.85rem 2rem 2.1rem 2rem",
              // maxWidth: '100%'
            }}
          >
            <div
              className='row w-100 mx-auto gap-4 row-gap-2'
              style={{
                color: theme === "dark" ? "rgb(210, 210, 210)" : "rgb(53, 53, 53)",
                fontWeight: "400",
              }}
            >
              <div className='col-12 p-0'>
                <div className='' style={{}}>
                  {t("auth.forgot.email")}
                  {/* <sup style={{ color: 'rgb(239, 112, 112)', fontSize: '15px', top: '-.25em' }}>*</sup> */}
                </div>
                <input
                  className='form-control auth-form-control py-2'
                  placeholder={t("auth.forgot.placeholder")}
                  name='email'
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  type='text'
                  style={{
                    // letterSpacing: '0.2em',
                    ...themeBasedSignupFormControl(theme),
                    minHeight: "43px",
                    borderWidth: emailError ? "2px" : "1px",
                    borderStyle: "solid",
                    borderColor: emailError ? "rgb(239, 112, 112)" : theme === "dark" ? "rgb(250, 229, 255)" : "rgb(141, 136, 143)",
                    // fontWeight: '600',
                    fontSize: "1.1rem",
                    marginTop: ".25rem",
                  }}
                />
              </div>
            </div>
            {/* {renderStep()} */}
            <button
              className='btn w-100 d-flex align-items-center justify-content-center gap-2 mx-auto'
              type='submit'
              disabled={formProcessing}
              style={{
                ...customRecoverButton,
                fontSize: "1.1rem",
                fontWeight: "600",
                letterSpacing: "0.02em",
                marginTop: "1.85rem",
                // maxWidth: '300px'
              }}
            >
              {formProcessing ? (
                <>
                  <span
                    className='spinner-border spinner-border-sm'
                    aria-hidden='true'
                    style={{
                      fontSize: "0.85rem",
                      height: "15px",
                      width: "15px",
                    }}
                  ></span>
                  <span role='status'>Loading...</span>
                </>
              ) : (
                t("auth.forgot.button")
              )}
            </button>
            <button
              className='btn w-100 d-flex align-items-center justify-content-center gap-2 mx-auto'
              type='button'
              onClick={navigateToLogin}
              disabled={false}
              style={{
                ...customCancelButton,
                fontSize: "1.1rem",
                fontWeight: "600",
                letterSpacing: "0.02em",
                marginTop: ".3rem",
                // maxWidth: '300px'
              }}
            >
              {t("modals.common.cancel")}
            </button>
          </form>
        </div>
        <div className='col-auto p-0'>
          <div
            className='text-center'
            style={{
              lineHeight: "1",
              fontSize: "1.2rem",
              color: "rgba(255,255,255,0.7)",
            }}
          >
            {t("app.login.form.power")}
          </div>
          <img
            className=''
            src={DcclLogo}
            alt='Logo'
            style={{
              width: "160px",
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default ForgotPasswordPage;
